module.exports = __webpack_public_path__ + "img/24-wagoneer-nav.cc0d65d9.png";